var _path, _path2, _path3, _path4, _path5, _path6, _mask, _g, _path7, _path8, _mask2, _g2, _path9, _mask3, _g3, _path10, _mask4, _g4, _path11, _path12, _mask5, _g5, _path13, _mask6, _g6, _path14, _mask7, _g7, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeatBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 116,
    viewBox: "0 0 141 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141 106H0L4.15879 116H136.841L141 106Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 36H141L136.841 32H4.15879L0 36Z",
    fill: "#F7F7F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141 36H0V106H141V36Z",
    fill: "#EAEAEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M138 39H3V103H138V39Z",
    fill: "#F7F7F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M138 78.5L3 45V103H138V78.5Z",
    fill: "#E36554"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M138 82L3 58.5V103H138V82Z",
    fill: "#C14534"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 53,
    width: 42,
    height: 22
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 53,
    width: 42,
    height: 22,
    rx: 1,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54 53H12V75H54V53Z",
    fill: "#4873E2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 53,
    width: 42,
    height: 0.880001,
    fill: "#254FBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 75L12 53L12.7119 53L12.7119 74.12L12 75Z",
    fill: "#254FBB"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M37.9328 53.8799L12.8135 74.9999H29.0192L54.305 53.8799H37.9328Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M57.5441 53.8799L33.2788 75H36.5271L59.9999 53.8799H57.5441Z",
    fill: "white"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 53,
    width: 11,
    height: 11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56 53.9167C56 53.4104 56.4104 53 56.9167 53H66.0833C66.5896 53 67 53.4104 67 53.9167V63.0833C67 63.5896 66.5896 64 66.0833 64H56.9167C56.4104 64 56 63.5896 56 63.0833V53.9167Z",
    fill: "#80CCE8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56 53.9167C56 53.4104 56.4104 53 56.9167 53H66.0833C66.5896 53 67 53.4104 67 53.9167V63.0833C67 63.5896 66.5896 64 66.0833 64H56.9167C56.4104 64 56 63.5896 56 63.0833V53.9167Z",
    fill: "#FAAC48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 53.4583C56 53.2052 56.2239 53 56.5 53V53C56.7761 53 57 53.2052 57 53.4583V63.5417C57 63.7948 56.7761 64 56.5 64V64C56.2239 64 56 63.7948 56 63.5417V53.4583Z",
    fill: "#FFD5A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9167 63H66.5417C66.7948 63 67 63.2239 67 63.5V63.5C67 63.7761 66.7948 64 66.5417 64H56L56.9167 63Z",
    fill: "#DD871A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5 64C66.2239 64 66 63.7948 66 63.5417L66 53.4583C66 53.2052 66.2239 53 66.5 53C66.7761 53 67 53.2052 67 53.4583L67 63.5417C67 63.7948 66.7761 64 66.5 64Z",
    fill: "#DD871A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 53.5C56 53.2239 56.2052 53 56.4583 53H67L66.0833 54H56.4583C56.2052 54 56 53.7761 56 53.5V53.5Z",
    fill: "#FFD5A0"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8333 59.2586L61.5476 55.75V57.7414L57.8333 61.25V59.2586ZM65.1666 59.2586L61.5476 55.75V57.7414L65.1666 61.25V59.2586Z",
    fill: "#333333"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 64,
    width: 11,
    height: 11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56 64.9167C56 64.4104 56.4104 64 56.9167 64H66.0833C66.5896 64 67 64.4104 67 64.9167V74.0833C67 74.5896 66.5896 75 66.0833 75H56.9167C56.4104 75 56 74.5896 56 74.0833V64.9167Z",
    fill: "#80CCE8"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56 64.9167C56 64.4104 56.4104 64 56.9167 64H66.0833C66.5896 64 67 64.4104 67 64.9167V74.0833C67 74.5896 66.5896 75 66.0833 75H56.9167C56.4104 75 56 74.5896 56 74.0833V64.9167Z",
    fill: "#FAAC48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 64.4583C56 64.2052 56.2239 64 56.5 64V64C56.7761 64 57 64.2052 57 64.4583V74.5417C57 74.7948 56.7761 75 56.5 75V75C56.2239 75 56 74.7948 56 74.5417V64.4583Z",
    fill: "#FFD5A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9167 74H66.5417C66.7948 74 67 74.2239 67 74.5V74.5C67 74.7761 66.7948 75 66.5417 75H56L56.9167 74Z",
    fill: "#DD871A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5 75C66.2239 75 66 74.7948 66 74.5417L66 64.4583C66 64.2052 66.2239 64 66.5 64V64C66.7761 64 67 64.2052 67 64.4583L67 74.5417C67 74.7948 66.7761 75 66.5 75V75Z",
    fill: "#DD871A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 64.5C56 64.2239 56.2052 64 56.4583 64H67L66.0833 65H56.4583C56.2052 65 56 64.7761 56 64.5V64.5Z",
    fill: "#FFD5A0"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1665 68.9914L61.4522 72.5L61.4522 70.5086L65.1665 67L65.1665 68.9914ZM57.8332 68.9914L61.4522 72.5L61.4522 70.5086L57.8332 67L57.8332 68.9914Z",
    fill: "#333333"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 75,
    y: 53,
    width: 42,
    height: 22
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 53,
    width: 42,
    height: 22,
    rx: 1,
    fill: "#C4C4C4"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117 53H75V75H117V53Z",
    fill: "#4873E2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 53,
    width: 42,
    height: 0.880001,
    fill: "#254FBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 75L75 53L75.7119 53L75.7119 74.12L75 75Z",
    fill: "#254FBB"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M100.933 53.8799L75.8135 74.9999H92.0192L117.305 53.8799H100.933Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M120.544 53.8799L96.2788 75H99.5271L123 53.8799H120.544Z",
    fill: "white"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "mask4",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 119,
    y: 53,
    width: 11,
    height: 11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119 53.9167C119 53.4104 119.41 53 119.917 53H129.083C129.59 53 130 53.4104 130 53.9167V63.0833C130 63.5896 129.59 64 129.083 64H119.917C119.41 64 119 63.5896 119 63.0833V53.9167Z",
    fill: "#80CCE8"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119 53.9167C119 53.4104 119.41 53 119.917 53H129.083C129.59 53 130 53.4104 130 53.9167V63.0833C130 63.5896 129.59 64 129.083 64H119.917C119.41 64 119 63.5896 119 63.0833V53.9167Z",
    fill: "#FAAC48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119 53.4583C119 53.2052 119.224 53 119.5 53V53C119.776 53 120 53.2052 120 53.4583V63.5417C120 63.7948 119.776 64 119.5 64V64C119.224 64 119 63.7948 119 63.5417V53.4583Z",
    fill: "#FFD5A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.917 63H129.542C129.795 63 130 63.2239 130 63.5V63.5C130 63.7761 129.795 64 129.542 64H119L119.917 63Z",
    fill: "#DD871A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.5 64C129.224 64 129 63.7948 129 63.5417L129 53.4583C129 53.2052 129.224 53 129.5 53C129.776 53 130 53.2052 130 53.4583L130 63.5417C130 63.7948 129.776 64 129.5 64Z",
    fill: "#DD871A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119 53.5C119 53.2239 119.205 53 119.458 53H130L129.083 54H119.458C119.205 54 119 53.7761 119 53.5V53.5Z",
    fill: "#FFD5A0"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.833 59.2586L124.548 55.75V57.7414L120.833 61.25V59.2586ZM128.167 59.2586L124.548 55.75V57.7414L128.167 61.25V59.2586Z",
    fill: "#333333"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "mask5",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 119,
    y: 64,
    width: 11,
    height: 11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119 64.9167C119 64.4104 119.41 64 119.917 64H129.083C129.59 64 130 64.4104 130 64.9167V74.0833C130 74.5896 129.59 75 129.083 75H119.917C119.41 75 119 74.5896 119 74.0833V64.9167Z",
    fill: "#80CCE8"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119 64.9167C119 64.4104 119.41 64 119.917 64H129.083C129.59 64 130 64.4104 130 64.9167V74.0833C130 74.5896 129.59 75 129.083 75H119.917C119.41 75 119 74.5896 119 74.0833V64.9167Z",
    fill: "#FAAC48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119 64.4583C119 64.2052 119.224 64 119.5 64V64C119.776 64 120 64.2052 120 64.4583V74.5417C120 74.7948 119.776 75 119.5 75V75C119.224 75 119 74.7948 119 74.5417V64.4583Z",
    fill: "#FFD5A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.917 74H129.542C129.795 74 130 74.2239 130 74.5V74.5C130 74.7761 129.795 75 129.542 75H119L119.917 74Z",
    fill: "#DD871A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.5 75C129.224 75 129 74.7948 129 74.5417L129 64.4583C129 64.2052 129.224 64 129.5 64V64C129.776 64 130 64.2052 130 64.4583L130 74.5417C130 74.7948 129.776 75 129.5 75V75Z",
    fill: "#DD871A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119 64.5C119 64.2239 119.205 64 119.458 64H130L129.083 65H119.458C119.205 65 119 64.7761 119 64.5V64.5Z",
    fill: "#FFD5A0"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.167 68.9914L124.452 72.5L124.452 70.5086L128.167 67L128.167 68.9914ZM120.833 68.9914L124.452 72.5L124.452 70.5086L120.833 67L120.833 68.9914Z",
    fill: "#333333"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "mask6",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 82,
    width: 36,
    height: 12
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 82,
    width: 36,
    height: 12,
    rx: 1,
    fill: "#FAAC48"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 82,
    width: 36,
    height: 12,
    rx: 1,
    fill: "#FAAC48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 82.5455C53 82.2442 53.2442 82 53.5455 82H88C88.5523 82 89 82.4477 89 83V83.0909H53.5455C53.2442 83.0909 53 82.8467 53 82.5455V82.5455Z",
    fill: "#FFD5A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89 93.4545C89 93.7558 88.7558 94 88.4545 94L54 94C53.4477 94 53 93.5523 53 93L53 92.9091L88.4545 92.9091C88.7558 92.9091 89 93.1533 89 93.4545V93.4545Z",
    fill: "#DD871A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5 82C53.2239 82 53 82.2239 53 82.5L53 94L54 92.9091L54 82.5C54 82.2239 53.7761 82 53.5 82V82Z",
    fill: "#FFD5A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5 94C88.7761 94 89 93.7761 89 93.5L89 82L88 83.0909L88 93.5C88 93.7761 88.2239 94 88.5 94V94Z",
    fill: "#DD871A"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3146 90C67.1677 90 67.597 89.625 67.597 88.8693C67.597 88.1648 67.2643 87.8466 66.3843 87.7273C65.7673 87.642 65.5419 87.4602 65.5419 87.0739C65.5419 86.6818 65.8156 86.4659 66.3146 86.4659C66.819 86.4659 67.0604 86.6818 67.0604 87.1307H67.5433C67.5433 86.375 67.1355 86 66.3307 86C65.5097 86 65.0644 86.3864 65.0644 87.125C65.0644 87.7898 65.3756 88.0909 66.2126 88.2102C66.8833 88.3068 67.1194 88.5 67.1194 88.9148C67.1194 89.3239 66.8512 89.5341 66.32 89.5341C65.7673 89.5341 65.4829 89.3011 65.4829 88.8352H65C65 89.6136 65.4454 90 66.3146 90Z",
    fill: "#333333"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1446 89.9318H69.5739V89.5H69.2573C68.9407 89.5 68.8602 89.4034 68.8602 89.0227V87.4091H69.5417V87H68.8602V86.2273H68.4363L68.3988 87H67.9105V87.4091H68.388V89.017C68.388 89.6591 68.6134 89.9318 69.1446 89.9318Z",
    fill: "#333333"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8809 90C71.2833 90 71.5945 89.8352 71.8198 89.5341L71.8359 89.9318H72.2384V88.017C72.2384 87.2898 71.8842 86.9318 71.1545 86.9318C70.4623 86.9318 70.0867 87.2557 70.0384 87.892H70.4999C70.516 87.5341 70.7467 87.3636 71.1384 87.3636C71.5677 87.3636 71.7662 87.5739 71.7662 88.0284V88.1875H71.1008C70.3228 88.1875 69.958 88.517 69.958 89.1023C69.958 89.6761 70.3121 90 70.8809 90ZM70.9506 89.5682C70.6018 89.5682 70.4301 89.3977 70.4301 89.0909C70.4301 88.7614 70.634 88.6023 71.1169 88.6023H71.7662V89.017C71.5999 89.375 71.3208 89.5682 70.9506 89.5682Z",
    fill: "#333333"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0701 89.9318H73.5423V88.2443C73.6335 87.6818 73.8857 87.4375 74.3364 87.4375H74.4759V86.9432H74.2881C73.8857 86.9432 73.6335 87.1307 73.494 87.5455L73.4726 87H73.0701V89.9318Z",
    fill: "#333333"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9041 89.9318H76.3333V89.5H76.0168C75.7002 89.5 75.6197 89.4034 75.6197 89.0227V87.4091H76.3011V87H75.6197V86.2273H75.1958L75.1583 87H74.67V87.4091H75.1475V89.017C75.1475 89.6591 75.3729 89.9318 75.9041 89.9318Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatBlock);
export default __webpack_public_path__ + "static/media/heatBlock.ccfc1dd48971062af2cdc8335531759e.svg";
export { ForwardRef as ReactComponent };